import { makeStyles } from '@paintscout/ui'
import React from 'react'
import type { MessageActivity } from '@paintscout/api'
import type { ActivityProps } from '@paintscout/ui'
import ActivityLink from 'src/components/common/ActivityLink'

const useChatActivityStyles = makeStyles((theme) => {
  return {
    link: {
      width: '100%'
    },
    root: {
      width: 'fit-content'
    },
    dot: {
      color: (props: ActivityProps) => {
        const msg = props.activity as MessageActivity
        const unread = msg?.details?.message?.from?.isCustomer === true && !msg?.details?.message?.readAt
        return unread ? theme.palette.warning.main : null
      }
    }
  }
})

export function ChatActivityComponent(props: ActivityProps) {
  const classes = useChatActivityStyles(props)

  return <ActivityLink {...props} classes={{ link: classes.link, root: classes.root, dot: classes.dot }} />
}
